export default {
    /*Tabs.jsx*/
    message_1_01: "Selecteer termijn:",
    message_1_02: "Dag",
    message_1_03: "Week",
    message_1_04: "Maand",
    message_1_05: "Smartphone",
    message_1_06: "Tablets",
    message_1_07: "Notebooks",
    /*Analytics.jsx*/
    message_2_01: "Overzicht",
    message_2_02: "Totaal aantal bezoekers",
    message_2_03: "Nieuwe gebruikers",
    message_2_04: "Terugkerende gebruikers",
    message_2_05: "Voorbije 24 uur",
    message_2_06: "Voorbije week",
    message_2_07: "Voorbije maand",
    message_2_08: "Besturingssysteem",
    message_2_09: "Datadownload vs. -upload",
    message_2_10: "Smartphone, tablets, notebooks",
    message_2_11: "Nieuwe vs. terugkerende gebruikers",
    message_2_12: "Totaal aantal bezoeken",
    message_2_13: "laden",
    /*App.jsx*/
    message_3_01: "Reset",
    message_3_02: "Rapporten",
    message_3_03: "Instellingen",
    message_3_04: "FAQ's",
    message_3_05: "Talen",
    message_3_06: "Uitloggen",
    /*RegistrationState.jsx*/
    message_4_01: "Reset",
    message_4_02: "Details",
    message_4_03: "Instellingen",
    message_4_04: "Branding",
    message_4_05: "Afgerond",
    /*DetailsState.jsx*/
    message_5_01: "Gelieve naam van uw onderneming en profiel van uw zaak in te vullen",
    message_5_02: "",
    message_5_03: "Naam van uw zaak",
    message_5_04: "Type zaak",
    message_5_05: "Personaliseer uw wifidienst of klik op 'Overslaan' om de standaardinstellingen te gebruiken. U kunt deze ook later bewerken.",
    message_5_06: "Overslaan",
    message_5_07: "Verdergaan",
    message_5_08: "Voer naam zaak in",
    message_5_09: "Uw bedrijfsnaam mag maximaal {ruleValue} tekens overschrijden",
    message_5_10: "Selecteer uw type zaak",
    message_5_11: "Café",
    message_5_12: "Restaurant",
    message_5_13: "Boekhandel",
    message_5_14: "Kledingzaak",
    message_5_15: "Schoenwinkel",
    message_5_16: "Winkel",
    message_5_17: "Koffiebar",
    message_5_18: "Supermarkt",
    message_5_19: "Tuincentrum",
    message_5_20: "Garage",
    message_5_21: "Apotheek",
    message_5_22: "Hotel",
    message_5_23: "Architect",
    message_5_24: "Huisartsenpraktijk",
    message_5_25: "Tandartsenpraktijk",
    message_5_26: "Kapper",
    message_5_27: "Schoonheidssalon",
    message_5_28: "Andere",
    /*SettingsState.jsx*/
    message_6_01: "Beheer uw wifi-instellingen",
    message_6_02: "Tijd gratis wifi",
    message_6_03: "Kies hoeveel gratis wifitijd u uw klanten wilt aanbieden",
    message_6_04: "Tijd gratis Wi-Fi",
    message_6_05: "Geen limiet",
    message_6_06: "15 minuten",
    message_6_07: "30 minuten",
    message_6_08: "1 uur",
    message_6_09: "2 uur",
    message_6_10: "4 uur",
    message_6_11: "Links social media",
    message_6_12: "Links social media",
    message_6_13: "Terug",
    message_6_14: "Volgende",
    message_6_15: "Selecteer de tijd gratis Wi-Fi",
    message_6_16: "Ongeldig URL-formaat voor Facebook-link",
    message_6_17: "Ongeldig URL-formaat voor Twitter-link",
    message_6_18: "Ongeldig URL-formaat voor Foursquare-link",
    /*BrandingState.jsx*/
    message_7_01: "Personaliseer het login scherm  voor uw bezoekers",
    message_7_02: "Naam wifidienst - voorbeeld : Welkom bij Bar Louis",
    message_7_03: "Personaliseer de wifinaam die aan uw klanten wordt getoond",
    message_7_04: "Wifinaam",
    message_7_05: "Adres van uw website",
    message_7_06: "Voeg uw website toe",
    message_7_07: "Adres van uw website",
    message_7_08: "Achtergrond",
    message_7_09: "Laad uw eigen foto op of selecteer een foto uit de fotobank als achtergrond",
    message_7_10: "Ik wens geen achtergrond",
    message_7_11: "Advertentie",
    message_7_12: "Uw advertentie uploaden",
    message_7_13: "Advertentie uploaden",
    message_7_14: "Terug",
    message_7_15: "Volgende",
    message_7_16: "Voer wifinaam in",
    message_7_17: "Uw Wi-Fi naam mag niet groter zijn dan {ruleValue} karakters",
    message_7_18: "Voer alsjeblieft de eigen URL van de handelaar in",
    message_7_19: "Ongeldig URL-formaat voor eigen URL van de klant",
    message_7_20: "Voorbeeld",
    message_7_21: "Laad uw eigen foto op",
    message_7_22: "Laad de foto uit de fotobank op",
    /*CompleteState.jsx*/
    message_8_01: "Proficiat",
    message_8_02: "u bent bijna klaar",
    message_8_03: "Klik op",
    message_8_04: "INSTELLINGEN",
    message_8_05: "Bewaren",
    message_8_06: "om wijzigingen toe te passen op uw portal.",
    message_8_07: "om dit later aan te passen.",
    message_8_08: "BESPAREN",
    message_8_09: "U kunt altijd terugkeren naar uw",
    message_8_10: "je bent klaar",
    message_8_11: "Nu kunt u uw standaardportaal gebruiken.",
    message_8_12: "Uw wijzigingen zijn opgeslagen",
    /*SaveConfirmation.jsx*/
    message_9_01: "Door te klikken op",
    message_9_02: "Verdergaan",
    message_9_03: "kiest u ervoor om de standaardtemplate van Proximus te negeren en de instellingen die u zelf hebt gekozen toe te passen op deze portal.",
    message_9_04: "Annuleer",
    message_9_05: "Uw wijzigingen werden bewaard en toegepast op de portal.",
    message_9_06: "OK",
    message_9_07: "Er is iets misgelopen. Probeer uit te loggen/in te loggen en herhaal deze stappen of neem contact op met Proximus",
    message_9_08: "OK",
    /*RedirectToManagementConsoleConfirmation.jsx*/
    message_10_01: "U gaat de CBU Portal Setup Assistant verlaten. Door op",
    message_10_02: "Opslaan en doorgaan",
    message_10_03: "u kiest om standaardsjabloon te overschrijven en uw eigen gekozen instellingen toe te passen op deze portal. Door te klikken op",
    message_10_04: "Annuleren",
    message_10_05: "u kiest om alle instellingen terug te zetten naar standaard.",
    message_10_06: "Er gaat iets mis. Probeer het uit te loggen / in te loggen en uw acties te herhalen of contact op te nemen met uw provider",
    message_10_07: "OK",
    /*ConfirmReset.jsx*/
    message_11_01: "Door te klikken op",
    message_11_02: "Verdergaan",
    message_11_03: "kies u ervoor om uw persoonlijke instellingen te verwijderen en zal de portal worden teruggezet naar de oorspronkelijke instellingen.",
    message_11_04: "Annuleren",
    /*Splash.jsx*/
    message_12_01: "Welkom bij onze gratis wifitoegang!",
    message_12_02: "",
    message_12_03: "Verbinden",
    message_12_04: "Maak je gratis account aan. Gelieve je gsm-nummer te vermelden",
    message_12_05: "GSM nummer",
    message_12_06: "Ik aanvaard de",
    message_12_07: "voorwaarden",
    message_12_08: "en de",
    message_12_09: "privacy policy",
    message_12_10: "Registreren",
    message_12_11: "Ik heb al een pincode",
    message_12_12: "Powered by",
    /*Verification.jsx*/
    message_13_01: "Activeer je account",
    message_13_02: "Voer de pincode in die je hebt ontvangen op:",
    message_13_04: "PIN",
    message_13_05: "Inloggen",
    message_13_06: "Nummer wijzigen",
    message_13_07: "Nieuwe pincode",
    message_13_08: "Powered by",
    /*Loading.jsx*/
    message_14_01: "Verbinden bezig, even geduld...",
    /*Interstitial.jsx*/
    message_15_01: "Klik op dit bericht",
    message_15_02: "of wacht 5 seconden...",
    /*Success.jsx*/
    message_16_01: "Welkom op onze gratis WiFi-toegang!",
    message_16_02: "Om ervoor te zorgen dat uw wachttijd sneller verloopt, hebben we ervoor gezorgd dat u gratis WiFi in ons Proximus-centrum kunt genieten.",
    message_16_03: "Proficiat, je bent verbonden",
    message_16_04: "Geniet nu van je gratis internet !",
    message_16_05: "Powered by",
    /*PreviewWindow.jsx*/
    message_17_01: "Gepersonaliseerde wifi-user journey",
    message_17_02: "Registratie",
    message_17_03: "Verifi�ren",
    message_17_04: "Laden bezig",
    message_17_05: "Advertentie",
    message_17_06: "Gelukt",
    /*OperatingSystem.jsx*/
    message_18_01: "Ander",
    /*TotalVisits.jsx*/
    message_19_01: "Totaal aantal bezoeken",
    /*DataDownloadVsUpload.jsx*/
    message_20_01: "Gedownload",
    message_20_02: "Ge�pload",
    /*NewVsReturning.jsx*/
    message_21_01: "Nieuwe gebruikers",
    message_21_02: "Terugkerende gebruikers",
    /*ImageUploadContainer.jsx*/
    message_22_01: "Advertentie verwijderen",
    message_22_02: "Kies bestand",
    /*BackgroundImageUploadContainer.jsx*/
    message_23_01: "Wis de achtergrond",
    message_23_02: "Kies uw bestand",
    message_23_03: "De foto's worden automatisch in het juiste formaat omgezet",
    message_23_04: "Kies een foto in landscape formaat",
    message_23_05: "Gelieve erop te letten dat de foto niet in lage resolutie is",
    message_23_06: "Aanbevolen afmetingen 1280 x 720",
    message_23_07: "Filenaam mag niet meer dan 45 karakters bevatten"
};


// WEBPACK FOOTER //
// ./src/locales/nl.js